// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ripple from 'vuetify/lib/directives/ripple'
import { themes } from './themes'

Vue.use(Vuetify, { directives: { ripple } })

const vuetify = new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  icons: {
    values: { expand: 'mdi-menu-down' },
  },
  // lang: { t: (key, ...params) => {i18n.t(key, params)} },

  theme: {
    options: {
      // Let Vuetify generate CSS custom properties for theme colors
      customProperties: true,
    },
    themes: {
      dark: themes.default.dark,
      light: themes.default.light
    },
  },
})

export default vuetify
